import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';
import { UserManagementModel } from './UserManagementModel';

@Service()
export default class UserManagementService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async Get(
        username: string, email: string, mobile: string, role: number[], providerName: string, pageIndex: string,
        pageSize: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            let url = window.$config.HostName + 'api/users?username=' + encodeURIComponent(username)
                + '&email=' + encodeURIComponent(email)
                + '&mobileNumber=' + encodeURIComponent(mobile)
                + '&pageIndex=' + pageIndex
                + '&pageSize=' + pageSize;
            if (role !== null && role !== undefined) {
                url += '&role=' + role;
            }
            if (providerName !== null && providerName !== undefined && providerName !== '') {
                url += '&providerName=' + encodeURIComponent(providerName);
            }
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async GeById(id: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/users/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data.result;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async Put(model: UserManagementModel): Promise<any> {
        this.loaderService.ShowLoader();
        const request = {
            id: model.id,
            username: model.username,
            email: model.email,
            mobileNumber: model.mobileNumber,
            isLocked: model.isLocked,
            roleId: model.roleId,
            providerId: model.providerId != null ? model.providerId : '',
            ProviderName: '',
            roleName: '',
            operatorName: '',

        };
        try {
            const url = window.$config.HostName + 'api/users';

            const result = await this.axiosService.axiosInstance.put(url, request);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async Post(model: UserManagementModel): Promise<any> {
        this.loaderService.ShowLoader();
        const request = {
            username: model.username,
            email: model.email,
            mobileNumber: model.mobileNumber,
            roleId: model.roleId,
            providerId: model.providerId != null ? model.providerId : '',
            isLocked: model.isLocked,
            ProviderName: '',
            roleName: '',
            operatorName: '',
        };
        try {
            const url = window.$config.HostName + 'api/users';
            const result = await this.axiosService.axiosInstance.post(url, request);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async ResendPasswordEmail(userName: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/users/resend-password-admin?userName=' + userName;
            const result = await this.axiosService.axiosInstance.post(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async GetLinkCertificate(id: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/certificate/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data.result;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async SwitchLock(id: string, isLocked: boolean): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            let url;
            if (isLocked) {
                url = window.$config.HostName + 'api/users/lock?id=' + id;
            } else {
                url = window.$config.HostName + 'api/users/unlock?id=' + id;
            }
            const result = await this.axiosService.axiosInstance.put(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async SwitchAdminToSuper(id: string,): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/users/switch-admin-to-super?id=' + id;
            const result = await this.axiosService.axiosInstance.put(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    /** Downloads Excel; same filters as grid; server applies role-based data scope. */
    public async ExportUsers(
        username: string,
        email: string,
        mobile: string,
        role: number[],
        providerName: string,
    ): Promise<{ success: boolean; errorMessage?: string }> {
        this.loaderService.ShowLoader();
        try {
            let url = window.$config.HostName + 'api/users/export?Username=' + encodeURIComponent(username)
                + '&Email=' + encodeURIComponent(email)
                + '&MobileNumber=' + encodeURIComponent(mobile);
            // Match Get(): always send role when defined (empty array -> &role=) so filters match the grid.
            if (role !== null && role !== undefined) {
                url += '&role=' + encodeURIComponent(Array.isArray(role) ? role.join(',') : String(role));
            }
            if (providerName !== null && providerName !== undefined && providerName !== '') {
                url += '&providerName=' + encodeURIComponent(providerName);
            }
            const response = await this.axiosService.axiosInstance.get(url, { responseType: 'blob' });
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'users-export.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
            this.loaderService.HideLoader();
            return { success: true };
        } catch (error) {
            this.loaderService.HideLoader();
            const resp = error && (error as any).response;
            if (resp && resp.data instanceof Blob) {
                try {
                    const text = await new Response(resp.data).text();
                    const j = JSON.parse(text);
                    return { success: false, errorMessage: j.errorMessage || j.message || 'Export failed' };
                } catch {
                    return { success: false, errorMessage: 'Export failed' };
                }
            }
            return { success: false, errorMessage: 'Export failed' };
        }
    }

}
